// 'notes' theme, copied here for customizations
// Source: https://github.com/jxnblk/mdx-deck/blob/508141d/packages/themes/notes.js
export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Annie+Use+Your+Telescope',
  fonts: {
    body: '"Annie Use Your Telescope", cursive',
  },
  styles: {
    Slide: {
      px: 4,
    },
    root: {
      textAlign: 'center',
    },
    // pre: {
    //   fontSize: ['0.5em'], // doesn't work for me, see https://github.com/jxnblk/mdx-deck/issues/554
    // },
  },
};
